import { render, staticRenderFns } from "./HouseOfCommons.vue?vue&type=template&id=804379da&"
import script from "./HouseOfCommons.vue?vue&type=script&lang=js&"
export * from "./HouseOfCommons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports